__turbopack_context__.v({
  "btn": "ButtonLocationDesktop-module__63y-kG__btn",
  "container": "ButtonLocationDesktop-module__63y-kG__container",
  "fadeInItems": "ButtonLocationDesktop-module__63y-kG__fadeInItems",
  "spacing--lg": "ButtonLocationDesktop-module__63y-kG__spacing--lg",
  "spacing--md": "ButtonLocationDesktop-module__63y-kG__spacing--md",
  "spacing--sm": "ButtonLocationDesktop-module__63y-kG__spacing--sm",
  "spacing--xl": "ButtonLocationDesktop-module__63y-kG__spacing--xl",
  "spacing--xs": "ButtonLocationDesktop-module__63y-kG__spacing--xs",
  "spacing--xxl": "ButtonLocationDesktop-module__63y-kG__spacing--xxl",
  "spacing--xxs": "ButtonLocationDesktop-module__63y-kG__spacing--xxs",
  "spacing--xxxl": "ButtonLocationDesktop-module__63y-kG__spacing--xxxl",
  "spacing--xxxs": "ButtonLocationDesktop-module__63y-kG__spacing--xxxs",
});
